"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Button, ButtonSize, ButtonVariant } from "../ui/v3/button";
function savingButton() {
  return /* @__PURE__ */ jsx("button", { disabled: true, children: "Saving..." });
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {});
    __publicField(this, "mounted", false);
    __publicField(this, "startResolving", () => {
      this.setState({ resolving: true });
    });
    __publicField(this, "cancelResolving", () => {
      this.setState({ resolving: false });
    });
    __publicField(this, "resolveException", () => {
      var self = this;
      var exception = self.props.exception;
      self.setState({ saving: true });
      self.props.exceptionResolver(
        self.state.resolutionMessage,
        exception,
        self.props.owner
      ).then(function() {
        if (self.mounted) {
          self.setState({ saving: false, resolving: false });
        }
      });
    });
    __publicField(this, "renderV3Reskin", () => {
      let styles = { display: "flex" };
      if (this.state.resolving) {
        styles = Object.assign(styles, {
          flexDirection: "column",
          gap: "16px"
        });
        return /* @__PURE__ */ jsxs("div", { className: "v3__type__body", style: styles, children: [
          this.props.exception.message_override,
          /* @__PURE__ */ jsx("div", { style: { display: "flex" }, children: this.resolvingExceptionV3Reskin() })
        ] });
      } else {
        styles = Object.assign(styles, {
          justifyContent: "space-between",
          gap: "24px"
        });
        return /* @__PURE__ */ jsxs("div", { className: "v3__type__body", style: styles, children: [
          /* @__PURE__ */ jsx("div", { style: { alignSelf: "center" }, children: this.props.exception.message_override }),
          this.resolveButton(this.props.exception)
        ] });
      }
    });
    __publicField(this, "resolvingException", () => {
      if (this.state.resolving) {
        return /* @__PURE__ */ jsxs("div", { className: "rules__resolve-exception-container", children: [
          /* @__PURE__ */ jsx(
            "textarea",
            {
              placeholder: "Resolution Message",
              rows: 4,
              value: this.state.resolutionMessage || "",
              onChange: (e) => this.setState({
                resolutionMessage: e.target.value
              })
            }
          ),
          this.resolveOrSaveButton(),
          /* @__PURE__ */ jsxs("span", { className: "button__cancel-wrapper", children: [
            " ",
            "or",
            /* @__PURE__ */ jsx("button", { className: "button--cancel", onClick: this.cancelResolving, children: "cancel" })
          ] })
        ] });
      }
    });
    __publicField(this, "resolvingExceptionV3Reskin", () => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            display: "flex",
            gap: "16px",
            flexDirection: "column",
            width: "100%"
          },
          children: [
            /* @__PURE__ */ jsx("div", { className: "v3__input-wrapper", children: /* @__PURE__ */ jsx(
              "textarea",
              {
                className: "v3__input",
                placeholder: "Provide a reason",
                value: this.state.resolutionMessage || "",
                onChange: (e) => this.setState({
                  resolutionMessage: e.target.value
                }),
                style: { height: "64px" }
              }
            ) }),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  flexDirection: "row",
                  alignSelf: "flex-end",
                  gap: "12px"
                },
                children: [
                  /* @__PURE__ */ jsx(
                    Button,
                    {
                      size: ButtonSize.Medium,
                      variant: ButtonVariant.Text,
                      onClick: this.cancelResolving,
                      style: { padding: "0" },
                      children: "Cancel"
                    }
                  ),
                  this.resolveOrSaveButtonV3Reskin()
                ]
              }
            )
          ]
        }
      );
    });
    __publicField(this, "resolveButton", (exception) => {
      if (!exception.resolved_at && !this.state.resolving && this.props.exceptionResolver) {
        const owner = this.props.owner || {};
        const message = owner.ignored ? "Resolve and Remove Ignore" : "Resolve";
        if (this.props.v3ReskinEnabled) {
          return /* @__PURE__ */ jsx(
            Button,
            {
              size: ButtonSize.Medium,
              variant: ButtonVariant.Outlined,
              onClick: this.startResolving,
              children: message
            }
          );
        } else {
          return /* @__PURE__ */ jsx(
            "button",
            {
              onClick: this.startResolving,
              className: "rules__resolve-button",
              children: message
            }
          );
        }
      }
    });
    __publicField(this, "resolveOrSaveButton", () => {
      if (this.state.saving) {
        return savingButton();
      } else {
        return /* @__PURE__ */ jsx(
          "button",
          {
            className: "rules__save-resolution-button",
            onClick: this.resolveException,
            children: "Resolve Exception"
          }
        );
      }
    });
    __publicField(this, "resolveOrSaveButtonV3Reskin", () => {
      if (this.state.saving) {
        return /* @__PURE__ */ jsx(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Outlined,
            disabled: true,
            children: "Saving..."
          }
        );
      } else {
        return /* @__PURE__ */ jsx(
          Button,
          {
            size: ButtonSize.Medium,
            variant: ButtonVariant.Outlined,
            onClick: this.resolveException,
            children: "Resolve"
          }
        );
      }
    });
  }
  componentDidMount() {
    this.mounted = true;
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    if (this.props.v3ReskinEnabled) {
      return this.renderV3Reskin();
    } else {
      var exception = this.props.exception;
      var itemClasses = classNames({
        rules__item: true,
        "rules__item--resolving": this.state.resolving
      });
      var exceptionClasses = classNames({
        rules__ignored: exception.resolved_at,
        "rules__item-text": true,
        "rules__item-text--resolving": this.state.resolving
      });
      return /* @__PURE__ */ jsxs("li", { className: itemClasses, children: [
        /* @__PURE__ */ jsx("span", { className: exceptionClasses, children: /* @__PURE__ */ jsx("span", { className: "text", children: exception.message_override }) }),
        this.resolvingException(),
        this.resolveButton(exception)
      ] });
    }
  }
}
